import { ProductEnum } from '@/api';
import type { ProductType } from '@/pages/Availability.page/types';

// Popup first so its card renders above Delivery when both share a date.
export const AVAILABILITY_PRODUCT_ORDER: ProductType[] = [
  ProductEnum.POPUP,
  ProductEnum.DELIVERY,
];
